import { Injectable } from '@angular/core';
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root',
})
export class UrlValidatorService {
  constructor(private router: Router) {}

  validateUrl(): Promise<void> {
    
    return new Promise((resolve) => {
      const currentUrl = window.location.pathname;
      const lowerCaseUrl = currentUrl.toLowerCase();
      console.log(`Current URL: ${currentUrl}, Lowercase URL: ${lowerCaseUrl}`);
      if (currentUrl !== lowerCaseUrl) {
        this.router.navigate([lowerCaseUrl]);
      }
      resolve();
    });
  }
}

export function validateUrlFactory(urlValidator: UrlValidatorService): () => Promise<void> {
  return () => urlValidator.validateUrl();
}